import { render, staticRenderFns } from "./SalesRefund.vue?vue&type=template&id=06aad19f&scoped=true&"
import script from "./SalesRefund.vue?vue&type=script&lang=js&"
export * from "./SalesRefund.vue?vue&type=script&lang=js&"
import style0 from "./SalesRefund.vue?vue&type=style&index=0&id=06aad19f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aad19f",
  null
  
)

export default component.exports